
 function Card({ title, text}: { title: string, text: string}) {
  return (
    <div className="flex flex-col justify-center items-center gap-y-2 p-2 bg-gray-400/20  rounded-lg drop-shadow-lg h-auto w-auto text-balance ">
        <h1 className="text-md font-bold text-white text-center ">{title}</h1>
        <span className=" text-sm text-neutral-100 font-semibold">{text}</span>
    </div>
  )
}

export default Card